import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-plan-linkage',
  templateUrl: './plan-linkage.component.html',
  styleUrl: './plan-linkage.component.css',
  standalone: false
})
export class PlanLinkageComponent {

  @Input() isActive: boolean = false;
  selectedTab: number = 0;


}
